class salesChannelRegister {

    static data = {
        logo: null,
        logo_dashboard: null,
        logo_mobile: null,
        saleschannel: null,
        email: null,
        market: null,
        socialIcon: null,
        socialTitle: null,
        facebookId: null,
        company_name: null,
        instagramId: null,
        ga_id: null,
        currency: null,
        vat: null,
        channels: null,
        languages: null,
        country_region: null,
        default_language: null,
        durations: null,
        default_duration: null
    };

    static set(type, value) {
        try {
            salesChannelRegister.data[type] = value;
            sessionStorage.setItem('saleschannel-' + type, value);
        } catch (e) {
            salesChannelRegister.data[type] = value;
        }
    }

    static get(type) {
        try {
            if (salesChannelRegister.data[type]) {
                return salesChannelRegister.data[type];
            } else {
                return sessionStorage.getItem('saleschannel-' + type);
            }
        } catch (e) {
            return salesChannelRegister[type];
        }
    }

    static remove(type) {
        if (salesChannelRegister.data[type]) {
            salesChannelRegister.data[type] = null;
        }
        try {
            sessionStorage.removeItem('saleschannel-' + type);
        } catch (e) {}
    }
}

export {salesChannelRegister}


// WEBPACK FOOTER //
// ./src/services/salesChannelRegister.js